import { Box, Button, Chip, styled } from '@mui/material';

import { COLORS } from '../../../../../configs/colors';

export const HistoryContainer = styled(Box)`
  background-color: ${COLORS.White};
  overflow: hidden;
`;

export const HistoryHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: ${COLORS.NavyBlue};
  color: ${COLORS.White};
`;

export const HistoryTitle = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  flex: 1;
`;

export const HistoryCount = styled(Box)`
  font-size: 12px;
  opacity: 0.8;
`;

export const FilterChipsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px;
  background-color: ${COLORS.BackgroundGrey};
  border-bottom: 1px solid ${COLORS.SubtleGrey};
`;

export const FilterChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>`
  font-size: 12px;
  height: 36px;
  background-color: ${({ isSelected }) => (isSelected ? COLORS.NavyBlue : COLORS.White)};
  color: ${({ isSelected }) => (isSelected ? COLORS.White : COLORS.NavyBlue)};
  border: 1px solid ${COLORS.NavyBlue};

  &:hover {
    background-color: ${({ isSelected }) =>
      isSelected ? COLORS.NavyBlue : COLORS.LightBlueBackground};
  }
`;

export const HistoryContent = styled(Box)`
  padding: 0 16px 16px;
`;

export const LoadingContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

export const NoHistoryText = styled(Box)`
  text-align: center;
  color: ${COLORS.Gray};
  font-size: 14px;
  padding: 24px;
`;

export const DateHeader = styled(Box)`
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.Gray};
  text-transform: uppercase;
  padding: 16px 0 8px;
  border-bottom: 1px solid ${COLORS.SubtleGrey};
  margin-bottom: 12px;
`;

export const TimelineList = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const TimelineItem = styled(Box)`
  display: flex;
  gap: 12px;
  position: relative;
  padding-bottom: 16px;

  &:last-child {
    padding-bottom: 0;
  }

  &::before {
    content: '';
    position: absolute;
    left: 11px;
    top: 24px;
    bottom: 0;
    width: 2px;
    background-color: ${COLORS.SubtleGrey};
  }

  &:last-child::before {
    display: none;
  }
`;

export const TimelineIcon = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'logType',
})<{ logType?: string }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  z-index: 1;
  background-color: ${({ logType }) => {
    switch (logType) {
      case 'status-change':
        return COLORS.NavyBlue;
      case 'note':
        return COLORS.LightGreen;
      case 'part-action':
        return COLORS.AmberOrange;
      default:
        return COLORS.Gray;
    }
  }};
  color: ${COLORS.White};

  svg {
    font-size: 14px;
  }
`;

export const TimelineContent = styled(Box)`
  flex: 1;
  min-width: 0;
`;

export const LogHeader = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const LogTimestamp = styled(Box)`
  font-size: 12px;
  color: ${COLORS.Gray};
`;

export const LogType = styled(Box)`
  font-size: 12px;
  font-weight: 600;
  color: ${COLORS.NavyBlue};
`;

export const LogStatus = styled(Box)`
  font-size: 11px;
  font-weight: 600;
  color: ${COLORS.NavyBlue};
  background-color: ${COLORS.LightBlueBackground};
  padding: 3px 10px;
  border-radius: 10px;
  white-space: nowrap;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StatusTransition = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const StatusArrow = styled(Box)`
  display: flex;
  align-items: center;
  color: ${COLORS.Gray};
  font-size: 14px;
`;

export const LogUser = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${COLORS.Black};
  margin-bottom: 4px;
`;

export const LogNotes = styled(Box)`
  font-size: 13px;
  color: ${COLORS.Gray};
  background-color: ${COLORS.BackgroundGrey};
  padding: 8px 10px;
  border-radius: 4px;
  margin-top: 4px;
  word-break: break-word;
  white-space: pre-wrap;

  a {
    color: ${COLORS.NavyBlue};
    text-decoration: underline;
    text-underline-offset: 2px;
    font-weight: 600;

    &:visited {
      color: ${COLORS.NavyBlue};
    }

    &:active {
      opacity: 0.7;
    }
  }
`;

export const FileAttachmentLink = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.NavyBlue};
  background-color: ${COLORS.LightBlueBackground};
  padding: 8px 12px;
  border-radius: 6px;
  margin-top: 4px;
  cursor: pointer;

  svg {
    font-size: 16px;
  }

  &:active {
    opacity: 0.7;
  }
`;

export const LoadMoreButton = styled(Button)`
  width: 100%;
  margin-top: 16px;
  text-transform: none;
  color: ${COLORS.NavyBlue};
  border: 1px solid ${COLORS.NavyBlue};
`;
